import React from 'react';

type PlayCanvasProps = {
    messageToPCRef: any;
    car: any;
    isPortrait: boolean;
    onMessageReceivedFromPC: (value: string) => void;
};

const PlayCanvasConnector: React.FC<PlayCanvasProps> = ({ messageToPCRef, car, isPortrait, onMessageReceivedFromPC}) => {

  const iframeRef = React.useRef<HTMLIFrameElement>(null);

  const GetMessageFromIframe = React.useCallback((event: MessageEvent) => {
    if (event.origin !== window.origin){
      console.error("React: Mensaje de un origen distinto")
      return;
    }
    onMessageReceivedFromPC(event.data);
  }, [onMessageReceivedFromPC]);

  React.useEffect(() => {
    window.addEventListener('message', GetMessageFromIframe);
    return () => {
      window.removeEventListener('message', GetMessageFromIframe);
    };
  }, [GetMessageFromIframe]);

  /*React.useEffect(() => {
    const iframeWindow = iframeRef.current?.contentWindow;
    if(messageToPC && iframeWindow){
      iframeWindow.postMessage(messageToPC, '*');
    }
  },[messageToPC]);*/

  const SendMessageToIframe = React.useCallback((messageToPC: any) => {
    const iframeWindow = iframeRef.current?.contentWindow;
    if(messageToPC && iframeWindow){
      iframeWindow.postMessage(messageToPC, '*');
    }
  }, []);

  React.useImperativeHandle(messageToPCRef, () => ({
    SendMessage: SendMessageToIframe,
  }));

  return (
    <div className={`pc-full-container ${isPortrait ? 'portrait':''}`}>
      <iframe ref={iframeRef} title='pc'
        className={`pc-container ${isPortrait ? 'portrait':''} ${true ? 'visible' : ''}`}
        src={`${car.url}`}
        allow={`xr-spatial-tracking; camera; fullscreen; microphone; gyroscope; accelerometer; scrolling='no' frameborder='0';`}
      />
    </div>
  );
}

export default PlayCanvasConnector;